import { render } from "./UserSubscriptionHistory.vue?vue&type=template&id=38c28cf3&scoped=true"
import script from "./UserSubscriptionHistory.vue?vue&type=script&lang=js"
export * from "./UserSubscriptionHistory.vue?vue&type=script&lang=js"

import "./UserSubscriptionHistory.vue?vue&type=style&index=0&id=38c28cf3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38c28cf3"]])

export default __exports__